import axios from 'axios'
import store from '../../store'

const API_URL = process.env.VUE_APP_API_BASE_URL
const API_URL_SUPPORT = process.env.VUE_APP_API_SUPPORT_URL
const API_URL_AIAGENT = process.env.VUE_APP_AI_AGENT_API_BASE_URL
class AuthService {
  login (user) {
    return axios.post(API_URL + 'login/admin', user)
  }

  loginWithResellerAuth (credentials) {
    return axios.post(API_URL + 'login/admin/reseller-auth', { Credentials: credentials })
  }

  supportLogin (loginModel) {
    return axios.post(API_URL_SUPPORT + '/login', loginModel)
  }

  exchangeTokenAndLoginWithCMAdmin (domain, orgAlias, token) {
    return axios.post(API_URL + 'oauth/common/token-exchange', { domain, orgAlias, token })
  }

  /**
   * Exchange token from external application for AI Agent JWT
   * @param {string} apiUrl - Full URL of external application's token exchange endpoint
   * @param {string} exchangeToken - Short-lived exchange token from external app
   * @param {string} organization - Organization alias (optional)
   */
  exchangeToken (apiUrl, exchangeToken, organization = '') {
    return axios.post(API_URL_AIAGENT + 'auth/token-exchange', {
      apiUrl: apiUrl,
      exchangeToken: exchangeToken,
      organization: organization
    })
  }

  /**
     * Validate current JWT token
     */
  validateToken () {
    return axios.get(API_URL_AIAGENT + 'auth/validate')
  }

  /**
   * Refresh access token using current valid token
   * @returns {Promise} Promise with new token and expiration
   */
  refreshToken () {
    return axios.post(API_URL_AIAGENT + 'auth/refresh')
  }

  /**
     * Logout (clear client-side state)
     */
  logout () {
    return axios.post(API_URL_AIAGENT + 'auth/logout')
  }

  /**
     * Store authentication data in localStorage
     * @param {object} authData - Response from token exchange
     */
  storeAuthData (authData) {
    debugger
    if (authData.accessToken) {
      localStorage.setItem('accessToken', authData.accessToken)
    }

    const userData = {
      userId: authData.userId,
      externalUserId: authData.externalUserId,
      displayName: authData.displayName,
      email: authData.email,
      scopeType: authData.scopeType,
      scopeId: authData.scopeId,
      roles: authData.roles
    }

    localStorage.setItem('ai_platform_user', JSON.stringify(userData))
    store.commit('auth/setUserData', userData)
  }

  /**
     * Get stored authentication data
     */
  getAuthData () {
    const token = localStorage.getItem('accessToken')
    const userJson = localStorage.getItem('ai_platform_user')

    if (!token || !userJson) {
      return null
    }

    try {
      const user = JSON.parse(userJson)
      return {
        token: token,
        user: user
      }
    } catch (error) {
      console.error('Failed to parse user data:', error)
      return null
    }
  }

  /**
     * Clear authentication data
     */
  clearAuthData () {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('ai_platform_user')
  }

  /**
     * Check if user is authenticated
     */
  isAuthenticated () {
    const authData = this.getAuthData()
    return authData !== null && authData.token !== null
  }

  /**
     * Get current user
     */
  getCurrentUser () {
    const authData = this.getAuthData()
    return authData ? authData.user : null
  }

  /**
     * Get JWT token for API calls
     */
  getToken () {
    return localStorage.getItem('accessToken')
  }
}

export default new AuthService()
